const topicsOnClick = 7;
let topicsDisplayed = 7;
let initialTopics = 7;
const topicsSelector = '.section-resources-lobby__topics .facetwp-radio';
const readMoreSelector = '.section-resources-lobby__load-more';

export default {
  init() {
    setTimeout(() => {
      const totalTopics = document.querySelectorAll(topicsSelector);

      if (totalTopics.length > 0) {
        this.watchTopics();
        this.watchReadMoreClick();
        this.watchTopicClick();
      }
    }, 800);
  },

  watchTopics() {
    const topics = document.querySelectorAll(topicsSelector);

    for (let i = 0; i < topics.length; i++) {
      const current = topics[i];

      if (i >= topicsDisplayed) {
        current.classList.add('d-none');
      } else {
        current.classList.remove('d-none');
      }
    }
  },

  watchReadMoreClick() {
    const readMore = document.querySelector(readMoreSelector);

    readMore.addEventListener("click", (item) => {
      item.preventDefault();

      topicsDisplayed = topicsDisplayed + topicsOnClick;

      this.watchTopics();

      setTimeout(() => {
        const totalTopics = document.querySelectorAll(topicsSelector);

        if (topicsDisplayed > totalTopics.length) {
          readMore.classList.add('d-none');
        }
      }, 500);
    });
  },

  watchTopicClick() {
    const clickWatcher = document.querySelector('.facetwp-facet.facetwp-facet-topics.facetwp-type-radio');

    clickWatcher.addEventListener("click", () => {
      this.toggleClasses();
    });
  },

  toggleClasses() {
    setTimeout(() => {
      const topics = document.querySelectorAll(topicsSelector);

      for (let i = 0; i < topics.length; i++) {
        const current = topics[i];

        if (i >= topicsDisplayed) {
          current.classList.add('d-none');
        } else {
          current.classList.remove('d-none');
        }
      }
    }, 3000);
  },
};

const resourcesAjax = function (post, callback) {
  const $ret = 0;
  const afApp = window.af_app;

  jQuery.ajax({
    type: 'POST',
    dataType: 'json',
    url: afApp.ajaxurl,
    data: post,
    success(data) {
      callback(data);
    },
  });

  return $ret;
};

export const loadResources = function (element, postsPerPage, newSearch) {
  const $this = jQuery(element);
  const resourcesLoadClass = 'ajax-is-loading-more';
  const resourcesFilterClass = 'ajax-filter-running';
  const postCounts = isNaN(postsPerPage) ? $this.data('posts-per-page') : postsPerPage;
  const items = newSearch ? 0 : jQuery('.resource-item').length;
  const terms = window.location.hash.replace('#/', '').split('/');
  const search_term = $('.section-resources-lobby__sidebar-search form input[name="search_input"]').val();

  $('body').addClass(resourcesLoadClass);

  if (!$('body').hasClass(resourcesFilterClass)) {
    $('body').addClass(resourcesFilterClass);

    if ($('body').hasClass(resourcesLoadClass)) {
      // Block
      $(document).find('.section-resources-lobby__items').block({
        message: null,
        overlayCSS: {
          background: '#f7f7f7',
          opacity: 0.6,
        },
      });
    }

    resourcesAjax({ items, terms, search_term, postCount: postCounts, action: 'loadmore_resources' }, resp => {
      $('body').removeClass(resourcesFilterClass);

      if (resp.pagination !== undefined && resp.pagination === false) {
        $this.hide();
      }

      if (resp.success && resp.html !== '') {
        if (newSearch) {
          $('.section-resources-lobby__results').html(`${resp.count} RESULTS`);
          $('.section-resources-lobby__items .row.articles').html(resp.html);
        } else {
          $this.parent().replaceWith(resp.html);
        }
      } else {
        if (newSearch) {
          $('.section-resources-lobby__results').html(`0 RESULTS`);
          $('.section-resources-lobby__items .row.articles').html(resp.html);
        } else {
          $this.parent().replaceWith(resp.html);
        }
        $this.hide();
      }

      // All done, Unblock
      $(document).find('.section-resources-lobby__items').unblock();

      setTimeout(() => {
        $('body').removeClass(resourcesLoadClass);
      }, 300);
    });
  }
};

(function ($, document) {
  const $doc = $(document);

  function watchClearClick() {
    const readMore = document.querySelector(readMoreSelector);
    const topics = document.querySelectorAll(topicsSelector);

    topicsDisplayed = initialTopics;

    for (let i = 0; i < topics.length; i++) {
      const current = topics[i];

      if (i >= topicsDisplayed) {
        current.classList.add('d-none');
      } else {
        current.classList.remove('d-none');
      }
    }

    readMore.classList.remove('d-none');
  }

  $doc.ready(() => {
    $doc.on('click', '.resources-load-more--btn', function (event) {
      event.preventDefault();
      loadResources(this);
    });

    $('.section-resources-lobby__sidebar-search form').on('submit', function (event) {
      event.preventDefault();
      loadResources('.resources-load-more--btn', NaN, true);
    });

    $doc.on('click', '.section-resources-lobby__clear', function (event) {
      event.preventDefault();
      const winloc = window.location;
      const url = `${winloc.protocol}//${winloc.host}${winloc.pathname}`;
      window.history.pushState({ path: url }, '', url);
      loadResources($('.resources-load-more--btn'));

      setTimeout(() => {
        watchClearClick();
      }, 2500);
    });

    $doc.on('resources:loadMore', '.resources-load-more--btn', function (event) {
      event.preventDefault();
      loadResources(this);
    });

    $('.filter-items__title').on('click', function() {
      /* Disable the collapse on desktop */
      if(window.innerWidth > 769) {
        return true;
      }
      const group = $(this).parents('.section-resources-lobby__filter-group');
      if (!group.hasClass('section-resources-lobby__filter-group--active')) {
        const closedHeight = group.height();

        group.css('height', 'auto');
        const openHeight = group.height();

        group.height(closedHeight).animate({
          height: openHeight,
        }, 350);

        group.addClass('section-resources-lobby__filter-group--active');
      } else {
        group.animate({
          height: 60,
        }, 350);

        group.removeClass('section-resources-lobby__filter-group--active');
      }
    });

    // Change clear filter btn style depending on screen size
    const mediaQuery = window.matchMedia('(min-width: 768px)');
    const clearFilter = $('.section-resources-lobby__buttons .section-resources-lobby__clear');

    function mediaChange(e) {
      // Check if the media query is true
      if (e.matches) {
        clearFilter.addClass('c-btn btn-theme-primary c-btn--dark');
        clearFilter.css('margin-left','0');
      } else {
        clearFilter.removeClass('c-btn btn-theme-primary c-btn--dark');
      }
    }

    // Initial run and register event listener
    mediaChange(mediaQuery);
    mediaQuery.addEventListener('change', (mediaChange));
  });
})(jQuery, document);



// WEBPACK FOOTER //
// ./scripts/routes/resources.js